import angular from 'angular';
import generalBusinessActualsComponent from './general-business-actuals.component';

let generalBusinessActualsModule = angular.module('generalBusinessActuals', [])
  .component('generalBusinessActuals', generalBusinessActualsComponent);

export default generalBusinessActualsModule;



// WEBPACK FOOTER //
// ./client/pages/expenses/general-business-actuals/general-business-actuals.js